<template>
  <div>
    <div class="top">
      <div class="logo">
        <img src="@/assets/png/home/zqw.png" alt="" />
      </div>
      <div class="tab">
        <div class="box" @click="toHome()">首页</div>
        <div class="box acitves" @click="toHundred()">编委会</div>
        <!-- <div class="box" @click="toAncestors()">寻亲问祖</div> -->
        <div class="box" @click="toGenealogy()">家谱库</div>
        <!-- <div class="box" @click="toPartyBuilding()">党建学习</div> -->
        <div class="box" @click="toDownload()">下载中心</div>
        <div class="box" @click="toAbout()">关于我们</div>
      </div>
    </div>
    <div class="banner">
      <img src="@/assets/png/home/banner.png" alt="" />
    </div>
    <div class="content">
      <div class="content-con">
        <div class="left"></div>
        <div class="right"></div>
      </div>
      <div class="con">
        <!-- <div class="top1">
              <img src="@/assets/png/home/smallLogo.png" alt="" />
              <p>下载中心</p>
              <div class="xian2"></div>
              <div class="more">+更多</div>
            </div> -->
        <div class="surname">
          <div class="top2">{{ $route.query.lastName }}氏编委会</div>
          <div class="cards-wrap">
            <router-link class="cards" v-for="(item, index) in slicedArrayList" :key="index" :to="{
              path: 'editorialBoard',
              query: {
                familyTreeId: $Base64.encode(
                  JSON.stringify(item.familyTreeId)
                ),
                name: $Base64.encode(JSON.stringify(item.ecName)),
              },
            }" target="_blank">
              <img src="@/assets/png/home/relatives.png" alt="" />
              <div class="co">
                <div class="a">
                  <div style="display: flex; width: 100%">
                    <p class="ec-name" :title="item.ecName">{{ item.ecName }}</p>
                  </div>
                </div>

                <div class="a c">
                  <p>地区:&nbsp;&nbsp;{{ item.areaName }}</p>
                </div>

                <div class="a c">
                  <p>创建:&nbsp;&nbsp;{{ item.createTime.slice(0, 10) }}</p>
                </div>
                <div class="le"></div>
                <div class="ri"></div>
              </div>
            </router-link>
          </div>
          <div class="bottom">
            <!-- <div class="box2">首页</div>
              <div class="box2">上一页</div>
              <div class="box2">1</div>
              <div class="box2">下一页</div>
              <div class="box2">尾页</div> -->
          </div>
        </div>
      </div>
    </div>
    <div class="foot">
      <div class="e">
        <div class="left2">
          <img src="@/assets/png/home/logo.png" alt="" />
        </div>
        <div class="right2">
          <p>版权所有:&nbsp;&nbsp;安徽图腾传承文化有限公司</p>
          <div style="display: flex">
            <p>客服电话:&nbsp;&nbsp;18963782919</p>
            <p style="margin-left: 20px">
              企业邮箱:&nbsp;&nbsp;zhzqwvip@163.com
            </p>
          </div>
          <div style="display: flex">
            <p>备案号:&nbsp;&nbsp;<a href="https://beian.miit.gov.cn/#/Integrated/index"
                target="_blank">皖ICP备1833721395-1号</a></p>
            <p style="margin-left: 20px">
              公安备案:&nbsp;&nbsp;皖公网安备 34019202000232号
            </p>
            <!-- <p style="margin-left: 20px">编委会管理中心</p> -->
            <a href="https://client.zqyp.net/" target="_blank" style="margin-left: 20px">编委会管理中心</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 寻亲问祖
      menusList: [],

      // 定义字体对象
      iconsObj: {
        125: "iconfont icon-user",
        103: "iconfont icon-tijikongjian",
        101: "iconfont icon-shangpin",
        102: "iconfont icon-danju",
        145: "iconfont icon-baobiao",
      },
      //激活的菜单项目
      activePath: "",
      // 控制左侧菜单列表的折叠布尔值
      isCollapse: false,

      slicedArrayList: [],
    };
  },

  created() {
    // 百家姓
    this.getSlicedArray();
  },
  methods: {
    goToNextPage(item) {
      // this.$router.push({
      //   path: '/editorialBoard',
      //   // params:{
      //   //   familyTreeId: item.familyTreeId,
      //   //   name: item.name,
      //   // },
      //   target:"_blank"
      // });
      // window.open('/editorialBoard', '_blank');
      // window.open(this.$router.resolve({ name: "tiaozhuan" }).href, "_blank");
      // localStorage.setItem("familyTreeId", item.familyTreeId);
      // localStorage.setItem("val", item.name);
    },

    boardClick(item) {
      this.$router.push({
        path: "./editorialBoard",
        query: {
          familyTreeId: item.familyTreeId,
          name: item.name,
        },
      });
    },

    async getSlicedArray() {
      let res = await this.$api.getFamilyTreeCommitteeList(this.$route.query.lastName)
      this.slicedArrayList = res.data;
    },

    // 首页
    toHome() {
      this.$router.push({
        path: "/",
      });
    },
    // 百家姓
    toHundred() {
      this.$router.push({
        path: "./surnameList",
      });
    },
    toAncestors() {
      this.$router.push({
        path: "./ancestors",
      });
    },
    // 家谱库
    toGenealogy() {
      this.$router.push({
        path: "./genealogy",
      });
      // location.href = "./genealogy.html";
    },

    // 党建学习
    toPartyBuilding() {
      this.$router.push({
        path: "./partyBuilding",
      });
    },

    // 下载中心
    toDownload() {
      this.$router.push({
        path: "./download",
      });
      // location.href = "./download.html";
    },
    toAbout() {
      this.$router.push({
        path: "./about",
      });
      // location.href = "./about.html";
    },
  },
};
</script>

<style scoped>
.top .tab .box {
  font-family: MicrosoftYaHei;
  font-size: 20px;
  color: #000000;
  font-weight: bold;
  cursor: pointer;
  height: 35px;
}

.acitves {
  border-bottom: 2px solid #cd4f4b;
}

.surname {
  width: 100%;
  height: 1000px;
  background-color: #fff;
}

.top2 {
  width: 100%;
  height: 50px;
  border-bottom: 2px solid #bf1c29;
  font-size: 20px;
  padding-left: 27px;
  color: #333333;
  display: flex;
  align-items: center;
  box-sizing: border-box;
}

.con1 {
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
}

.cards-wrap {
  width: 100%;
  padding: 50px 40px 50px 40px;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.cards {
  width: calc((100% - 40px) / 3);
  position: relative;
  height: 150px;
  font-size: 18px;
  font-weight: normal;
  color: #333333;
  cursor: pointer;
  z-index: 99999;
  text-decoration: none;
  display: block;
}

.ec-name {
  font-size: 23px;
  font-weight: bold;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.cards img {
  width: 100%;
  height: 8px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 22;
}

.co {
  position: absolute;
  height: 100%;
  width: 100%;
  background-image: url(@/assets/png/home/3.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.le {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url(@/assets/png/home/2.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.ri {
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background-image: url(@/assets/png/home/4.png);
  background-repeat: no-repeat;
  background-size: 110% 130%;
  background-position: -37px -40px;
}

.a {
  width: 100%;
  height: 20%;
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  padding-left: 14px;
  align-items: center;
  box-sizing: border-box;
  font-size: 16px;
  font-weight: 600;
}

.b {
  margin-top: 10px;
  padding-right: 40px;
}

.c {
  margin-top: 10px;
  padding-right: 40px;
}

.a p {
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.bottom {
  width: 100%;
  height: 131px;

  display: flex;
  align-items: center;
  padding-left: 40px;
}

.box2 {
  padding: 10px;
  border: 1px solid #c2c2c2;
  margin-bottom: 20px;
}

* {
  margin: 0;
  padding: 0;
}

body {
  background-color: #f8f8f8;
}

.top {
  width: 100%;
  height: 145px;
  background: url(@/assets/png/home/top.png) no-repeat;
  background-size: 100% 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.top .logo {
  width: 170px;
  height: 73px;
}

.logo>img {
  width: 100%;
  height: 100%;
}

.top .tab {
  /* width: 612px; */
  width: 38%;
  display: flex;
  justify-content: space-between;
}

.top .tab .box {
  font-family: MicrosoftYaHei;
  font-size: 20px;
  color: #000000;
  /* font-weight: 500; */
}

.banner {
  width: 100%;
  height: 400px;
}

.banner img {
  width: 100%;
  height: 100%;
}

.content {
  width: 100%;
  height: calc(1996px - 645px - 161px);
  position: relative;
}

.content .content-con {
  position: absolute;
  left: 16%;
  width: 67%;
  height: calc(1996px - 645px - 161px);
  display: flex;
}

.content .content-con .left {
  width: 50%;
  height: calc(1996px - 645px - 161px - 280px);
  background: url(@/assets/png/home/left.png) no-repeat;
  background-size: 100% 100%;
  margin-top: 50px;
  margin-bottom: 230px;
  z-index: 22;
}

.content .content-con .right {
  width: 50%;
  height: calc(1996px - 645px - 161px - 280px);
  background: url(@/assets/png/home/right.png) no-repeat;
  background-size: 100% 100%;
  margin-top: 280px;
  z-index: 22;
}

.con {
  width: 67%;
  height: calc(1996px - 645px - 161px);

  margin: 0 auto;
  padding-top: 50px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

.top1 {
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 25px;
  justify-content: space-between;
  position: relative;
}

.xian2 {
  width: 88%;
  height: 1px;
  background-color: #dddddd;
}

.more {
  position: absolute;
  right: 0;
  top: 0;
  font-size: 12px;
  color: #c2c2c2;
}

.e {
  width: 62%;
  height: 100%;
  display: flex;
  align-items: center;
}

.left2 {
  width: 15%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.right2 {
  width: 85%;
  height: 60%;
  font-size: 14px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}

.foot {
  width: 100%;
  height: 161px;
  background-image: url(@/assets/png/home/bottom.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding-left: 20%;
  box-sizing: border-box;
}
</style>
